<template>
    <el-drawer :modal="false" 
        title="Investor Profile"
        :visible.sync="drawerInvestorProfile"
        class="drawer-investor-profile"
        size="50%"
    >
        <b-container>
            <el-collapse v-model="activeName" accordion>
                <el-collapse-item name="personal" class="my-3">
                    <div slot="title" class="collapse-header">
                        <h3 class="mb-0">Personal Detail</h3>
                    </div>
                    <PersonalDetailForm />
                </el-collapse-item>

                <el-collapse-item name="bank" class="my-3">
                    <div slot="title" class="collapse-header">
                        <h3 class="mb-0">Bank Detail</h3>
                    </div>
                    <BankDetailForm />
                </el-collapse-item>
            </el-collapse>
        </b-container>
    </el-drawer>
</template>
<script>
import { Drawer, Collapse, CollapseItem } from 'element-ui'
import PersonalDetailForm from '@/views/FundsMgmtInvestors/InvestorModals/InvestorForms/PersonalDetailForm'
import BankDetailForm from '@/views/FundsMgmtInvestors/InvestorModals/InvestorForms/BankDetailForm'

export default {
    components: {
        PersonalDetailForm,
        BankDetailForm,
        [Drawer.name]: Drawer,
        [Collapse.name]: Collapse,
        [CollapseItem.name]: CollapseItem,
    },
    data() {
        return {
            drawerInvestorProfile: false,
            activeName: '',
        }
    },
    methods: {
        viewInvestorProfile() {
            this.drawerInvestorProfile = !this.drawerInvestorProfile;
        }
    }
}
</script>